module.exports = __webpack_public_path__ + "assets/img/goods_adv5.f979963d.jpg";